/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'underscore',
	'../../../lib/@waca/upgrades/UpgradeBase',
	'./utils/WidgetUpgradeUtils'
], (_, UpgradeBase, WidgetUpgradeUtils) => {

	/**
	* Upgrade VIDA Legend property - Change the Font Size. Currently we have four values for Font size. We will now have only 3 values. This script will check for the current user defined value (if any), and map it to the right value.
	**/

	class VIDALegendFontSizeMappingUpgrade extends UpgradeBase {

		constructor() {
			super();
			this.VERSION = 1400;
		}

		/**
		 * Perform upgrade
		 *
		 * @param {object} spec - spec to perform upgrade on
		 *
		 * @return {Promise} Promise to be resolved when upgrade performed
		 */
		up(spec){
			if (!WidgetUpgradeUtils.specHasWidgets(spec)) {
				return Promise.resolve(spec);
			}
			_.each(spec.widgets, model => {
				if(model && WidgetUpgradeUtils.isLiveWidgetModel(model) && model.properties){
					this._legendFontSizeMappingUpgrade(model);
				}
			});
			return Promise.resolve(spec);
		}

		// Downgrades are not available in CA
		down(spec) {
			return Promise.resolve(spec);
		}

		/**
		 * If font size property is defined, then check the defined size and map it to the right value. Here is the mapping:
		 * 12px -> 11px
		 * 14px -> 14px
		 * 16px, 24px -> 16px
		 * If no font size is defined (default is 11px), then don't do anything
		 * @param {object} model 
		 */
		_legendFontSizeMappingUpgrade(model){
			const fontSizePropName = 'widget.legend.font';
			const fontSizePropOfWidget = WidgetUpgradeUtils.findProperty(fontSizePropName, model.properties);

			if(fontSizePropOfWidget){
				const fontSize = fontSizePropOfWidget.value.trim();
				const fontMap = {
					'12px': '11px',
					'24px': '16px'
				};

				const mappedValue = fontMap[fontSize];

				//except for 14px and 16px, remap the Legend font size
				if(mappedValue){
					//filter out the font size prop from the model properties so that the new prop can be pushed
					model.properties = _.filter(model.properties, (prop) => { return (fontSizePropName!== prop.id); });

					model.properties.push({
						id: fontSizePropName,
						value: mappedValue
					});
				}
			}
		}
	}

	return new VIDALegendFontSizeMappingUpgrade();
});